import { UserKindWizardResult, UserKindWizardResultUnion } from '@app/queryTyping';

type StepResultType = Pick<UserKindWizardResultUnion, '__typename'>;

export const isUserKindResult = (step: StepResultType): step is UserKindWizardResult => (
  // eslint-disable-next-line no-underscore-dangle
  step.__typename === 'UserKindWizardResult'
);
